/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { BusinessObjectDefinition } from '../model/businessObjectDefinition';
import { BusinessObjectDefinitionAttributesUpdateRequest } from '../model/businessObjectDefinitionAttributesUpdateRequest';
import { BusinessObjectDefinitionCreateRequest } from '../model/businessObjectDefinitionCreateRequest';
import { BusinessObjectDefinitionDepartmentUpdateRequest } from '../model/businessObjectDefinitionDepartmentUpdateRequest';
import { BusinessObjectDefinitionDescriptiveInformationUpdateRequest } from '../model/businessObjectDefinitionDescriptiveInformationUpdateRequest';
import { BusinessObjectDefinitionKeys } from '../model/businessObjectDefinitionKeys';
import { BusinessObjectDefinitionSearchRequest } from '../model/businessObjectDefinitionSearchRequest';
import { BusinessObjectDefinitionSearchResponse } from '../model/businessObjectDefinitionSearchResponse';
import { BusinessObjectDefinitionUpdateRequest } from '../model/businessObjectDefinitionUpdateRequest';
import { ErrorInformation } from '../model/errorInformation';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class BusinessObjectDefinitionService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * createBusinessObjectDefinition
     * Creates a new business object definition. &lt;p&gt;Requires WRITE permission on namespace&lt;/p&gt;
     * @param businessObjectDefinitionCreateRequest the information needed to create the business object definition.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectDefinitionCreateBusinessObjectDefinition(businessObjectDefinitionCreateRequest: BusinessObjectDefinitionCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectDefinition>;
    public businessObjectDefinitionCreateBusinessObjectDefinition(businessObjectDefinitionCreateRequest: BusinessObjectDefinitionCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectDefinition>>;
    public businessObjectDefinitionCreateBusinessObjectDefinition(businessObjectDefinitionCreateRequest: BusinessObjectDefinitionCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectDefinition>>;
    public businessObjectDefinitionCreateBusinessObjectDefinition(businessObjectDefinitionCreateRequest: BusinessObjectDefinitionCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (businessObjectDefinitionCreateRequest === null || businessObjectDefinitionCreateRequest === undefined) {
            throw new Error('Required parameter businessObjectDefinitionCreateRequest was null or undefined when calling businessObjectDefinitionCreateBusinessObjectDefinition.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<BusinessObjectDefinition>(`${this.configuration.basePath}/businessObjectDefinitions`,
            businessObjectDefinitionCreateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteBusinessObjectDefinition
     * Deletes an existing business object definition by key. &lt;p&gt;Requires WRITE permission on namespace&lt;/p&gt;
     * @param namespace the namespace code
     * @param businessObjectDefinitionName the business object definition name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectDefinitionDeleteBusinessObjectDefinition(namespace: string, businessObjectDefinitionName: string, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectDefinition>;
    public businessObjectDefinitionDeleteBusinessObjectDefinition(namespace: string, businessObjectDefinitionName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectDefinition>>;
    public businessObjectDefinitionDeleteBusinessObjectDefinition(namespace: string, businessObjectDefinitionName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectDefinition>>;
    public businessObjectDefinitionDeleteBusinessObjectDefinition(namespace: string, businessObjectDefinitionName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectDefinitionDeleteBusinessObjectDefinition.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling businessObjectDefinitionDeleteBusinessObjectDefinition.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<BusinessObjectDefinition>(`${this.configuration.basePath}/businessObjectDefinitions/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getBusinessObjectDefinition
     * Gets an existing business object definition by key.
     * @param namespace the namespace code
     * @param businessObjectDefinitionName the business object definition name
     * @param includeBusinessObjectDefinitionUpdateHistory 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectDefinitionGetBusinessObjectDefinition(namespace: string, businessObjectDefinitionName: string, includeBusinessObjectDefinitionUpdateHistory?: boolean, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectDefinition>;
    public businessObjectDefinitionGetBusinessObjectDefinition(namespace: string, businessObjectDefinitionName: string, includeBusinessObjectDefinitionUpdateHistory?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectDefinition>>;
    public businessObjectDefinitionGetBusinessObjectDefinition(namespace: string, businessObjectDefinitionName: string, includeBusinessObjectDefinitionUpdateHistory?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectDefinition>>;
    public businessObjectDefinitionGetBusinessObjectDefinition(namespace: string, businessObjectDefinitionName: string, includeBusinessObjectDefinitionUpdateHistory?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectDefinitionGetBusinessObjectDefinition.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling businessObjectDefinitionGetBusinessObjectDefinition.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (includeBusinessObjectDefinitionUpdateHistory !== undefined && includeBusinessObjectDefinitionUpdateHistory !== null) {
            queryParameters = queryParameters.set('includeBusinessObjectDefinitionUpdateHistory', <any>includeBusinessObjectDefinitionUpdateHistory);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<BusinessObjectDefinition>(`${this.configuration.basePath}/businessObjectDefinitions/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getBusinessObjectDefinitions
     * Gets the list of business object definitions that are defined in the system.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectDefinitionGetBusinessObjectDefinitions(observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectDefinitionKeys>;
    public businessObjectDefinitionGetBusinessObjectDefinitions(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectDefinitionKeys>>;
    public businessObjectDefinitionGetBusinessObjectDefinitions(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectDefinitionKeys>>;
    public businessObjectDefinitionGetBusinessObjectDefinitions(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<BusinessObjectDefinitionKeys>(`${this.configuration.basePath}/businessObjectDefinitions`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getBusinessObjectDefinitions
     * Gets the list of business object definitions that are defined in the system.
     * @param namespace the namespace code
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectDefinitionGetBusinessObjectDefinitions1(namespace: string, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectDefinitionKeys>;
    public businessObjectDefinitionGetBusinessObjectDefinitions1(namespace: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectDefinitionKeys>>;
    public businessObjectDefinitionGetBusinessObjectDefinitions1(namespace: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectDefinitionKeys>>;
    public businessObjectDefinitionGetBusinessObjectDefinitions1(namespace: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectDefinitionGetBusinessObjectDefinitions1.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<BusinessObjectDefinitionKeys>(`${this.configuration.basePath}/businessObjectDefinitions/namespaces/${encodeURIComponent(String(namespace))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * searchBusinessObjectDefinitions
     * Searches across all business object definitions that are defined in the system per specified search filters and keys
     * @param businessObjectDefinitionSearchRequest the information needed to search across the business object definitions
     * @param fields A comma-separated list of fields to be retrieved with each business object definition entity. Valid options: dataProviderName, shortDescription, displayName
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectDefinitionSearchBusinessObjectDefinitions(businessObjectDefinitionSearchRequest: BusinessObjectDefinitionSearchRequest, fields?: string, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectDefinitionSearchResponse>;
    public businessObjectDefinitionSearchBusinessObjectDefinitions(businessObjectDefinitionSearchRequest: BusinessObjectDefinitionSearchRequest, fields?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectDefinitionSearchResponse>>;
    public businessObjectDefinitionSearchBusinessObjectDefinitions(businessObjectDefinitionSearchRequest: BusinessObjectDefinitionSearchRequest, fields?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectDefinitionSearchResponse>>;
    public businessObjectDefinitionSearchBusinessObjectDefinitions(businessObjectDefinitionSearchRequest: BusinessObjectDefinitionSearchRequest, fields?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (businessObjectDefinitionSearchRequest === null || businessObjectDefinitionSearchRequest === undefined) {
            throw new Error('Required parameter businessObjectDefinitionSearchRequest was null or undefined when calling businessObjectDefinitionSearchBusinessObjectDefinitions.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (fields !== undefined && fields !== null) {
            queryParameters = queryParameters.set('fields', <any>fields);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<BusinessObjectDefinitionSearchResponse>(`${this.configuration.basePath}/businessObjectDefinitions/search`,
            businessObjectDefinitionSearchRequest,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateBusinessObjectDefinition
     * Updates an existing business object definition by key. &lt;p&gt;Requires WRITE permission on namespace&lt;/p&gt; &lt;p&gt; If attributes are supplied in the request, this endpoint replaces the entire list of attributes on the business object definition with the contents of the request. Observe this example: &lt;ol&gt; &lt;li&gt;Three attributes present on the existing business object definition.&lt;/li&gt; &lt;li&gt;This endpoint is called with a single attribute in the request with an updated value.&lt;/li&gt; &lt;li&gt;After this operation the business object definition will have only one attribute – which is probably not the desired outcome.&lt;/li&gt; &lt;li&gt;Instead, supply all existing attributes and provide updated values and additional attributes as needed. The only case when an existing attribute should be left out is to remove the attribute.&lt;/li&gt; &lt;/ol&gt; &lt;/p&gt;
     * @param namespace the namespace code
     * @param businessObjectDefinitionName the name of the business object definition to update
     * @param businessObjectDefinitionUpdateRequest the information needed to update the business object definition
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectDefinitionUpdateBusinessObjectDefinition(namespace: string, businessObjectDefinitionName: string, businessObjectDefinitionUpdateRequest: BusinessObjectDefinitionUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectDefinition>;
    public businessObjectDefinitionUpdateBusinessObjectDefinition(namespace: string, businessObjectDefinitionName: string, businessObjectDefinitionUpdateRequest: BusinessObjectDefinitionUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectDefinition>>;
    public businessObjectDefinitionUpdateBusinessObjectDefinition(namespace: string, businessObjectDefinitionName: string, businessObjectDefinitionUpdateRequest: BusinessObjectDefinitionUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectDefinition>>;
    public businessObjectDefinitionUpdateBusinessObjectDefinition(namespace: string, businessObjectDefinitionName: string, businessObjectDefinitionUpdateRequest: BusinessObjectDefinitionUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectDefinitionUpdateBusinessObjectDefinition.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling businessObjectDefinitionUpdateBusinessObjectDefinition.');
        }
        if (businessObjectDefinitionUpdateRequest === null || businessObjectDefinitionUpdateRequest === undefined) {
            throw new Error('Required parameter businessObjectDefinitionUpdateRequest was null or undefined when calling businessObjectDefinitionUpdateBusinessObjectDefinition.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<BusinessObjectDefinition>(`${this.configuration.basePath}/businessObjectDefinitions/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}`,
            businessObjectDefinitionUpdateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateBusinessObjectDefinitionAttributes
     * Updates attributes for an existing business object definition. &lt;p&gt;Requires WRITE or WRITE_DESCRIPTIVE_CONTENT permission on namespace&lt;/p&gt; &lt;p&gt; This endpoint replaces the entire list of attributes on the business object definition with the contents of the request. Observe this example: &lt;ol&gt; &lt;li&gt;Three attributes present on the existing business object definition.&lt;/li&gt; &lt;li&gt;This endpoint is called with a single attribute in the request with an updated value.&lt;/li&gt; &lt;li&gt;After this operation the business object definition will have only one attribute – which is probably not the desired outcome.&lt;/li&gt; &lt;li&gt;Instead, supply all existing attributes and provide updated values and additional attributes as needed. The only case when an existing attribute should be left out is to remove the attribute.&lt;/li&gt; &lt;/ol&gt; &lt;/p&gt;
     * @param namespace the namespace code
     * @param businessObjectDefinitionName the name of the business object definition to update
     * @param businessObjectDefinitionAttributesUpdateRequest the information needed to update the business object definition attributes
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectDefinitionUpdateBusinessObjectDefinitionAttributes(namespace: string, businessObjectDefinitionName: string, businessObjectDefinitionAttributesUpdateRequest: BusinessObjectDefinitionAttributesUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectDefinition>;
    public businessObjectDefinitionUpdateBusinessObjectDefinitionAttributes(namespace: string, businessObjectDefinitionName: string, businessObjectDefinitionAttributesUpdateRequest: BusinessObjectDefinitionAttributesUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectDefinition>>;
    public businessObjectDefinitionUpdateBusinessObjectDefinitionAttributes(namespace: string, businessObjectDefinitionName: string, businessObjectDefinitionAttributesUpdateRequest: BusinessObjectDefinitionAttributesUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectDefinition>>;
    public businessObjectDefinitionUpdateBusinessObjectDefinitionAttributes(namespace: string, businessObjectDefinitionName: string, businessObjectDefinitionAttributesUpdateRequest: BusinessObjectDefinitionAttributesUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectDefinitionUpdateBusinessObjectDefinitionAttributes.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling businessObjectDefinitionUpdateBusinessObjectDefinitionAttributes.');
        }
        if (businessObjectDefinitionAttributesUpdateRequest === null || businessObjectDefinitionAttributesUpdateRequest === undefined) {
            throw new Error('Required parameter businessObjectDefinitionAttributesUpdateRequest was null or undefined when calling businessObjectDefinitionUpdateBusinessObjectDefinitionAttributes.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<BusinessObjectDefinition>(`${this.configuration.basePath}/businessObjectDefinitionAttributes/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}`,
            businessObjectDefinitionAttributesUpdateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateBusinessObjectDefinitionDepartment
     * Updates an existing business object definition department by code. &lt;p&gt;Requires WRITE or WRITE_DESCRIPTIVE_CONTENT permission on namespace&lt;/p&gt;
     * @param namespace the namespace code
     * @param businessObjectDefinitionName the name of the business object definition to update
     * @param businessObjectDefinitionDepartmentUpdateRequest the information needed to update the business object definition
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectDefinitionUpdateBusinessObjectDefinitionDepartment(namespace: string, businessObjectDefinitionName: string, businessObjectDefinitionDepartmentUpdateRequest: BusinessObjectDefinitionDepartmentUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectDefinition>;
    public businessObjectDefinitionUpdateBusinessObjectDefinitionDepartment(namespace: string, businessObjectDefinitionName: string, businessObjectDefinitionDepartmentUpdateRequest: BusinessObjectDefinitionDepartmentUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectDefinition>>;
    public businessObjectDefinitionUpdateBusinessObjectDefinitionDepartment(namespace: string, businessObjectDefinitionName: string, businessObjectDefinitionDepartmentUpdateRequest: BusinessObjectDefinitionDepartmentUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectDefinition>>;
    public businessObjectDefinitionUpdateBusinessObjectDefinitionDepartment(namespace: string, businessObjectDefinitionName: string, businessObjectDefinitionDepartmentUpdateRequest: BusinessObjectDefinitionDepartmentUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectDefinitionUpdateBusinessObjectDefinitionDepartment.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling businessObjectDefinitionUpdateBusinessObjectDefinitionDepartment.');
        }
        if (businessObjectDefinitionDepartmentUpdateRequest === null || businessObjectDefinitionDepartmentUpdateRequest === undefined) {
            throw new Error('Required parameter businessObjectDefinitionDepartmentUpdateRequest was null or undefined when calling businessObjectDefinitionUpdateBusinessObjectDefinitionDepartment.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<BusinessObjectDefinition>(`${this.configuration.basePath}/businessObjectDefinitionDepartment/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}`,
            businessObjectDefinitionDepartmentUpdateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateBusinessObjectDefinitionDescriptiveInformation
     * Updates an existing business object definition descriptive information by key. &lt;p&gt;Requires WRITE or WRITE_DESCRIPTIVE_CONTENT permission on namespace&lt;/p&gt;
     * @param namespace the namespace code
     * @param businessObjectDefinitionName the name of the business object definition to update
     * @param businessObjectDefinitionDescriptiveInformationUpdateRequest the information needed to update the business object definition
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectDefinitionUpdateBusinessObjectDefinitionDescriptiveInformation(namespace: string, businessObjectDefinitionName: string, businessObjectDefinitionDescriptiveInformationUpdateRequest: BusinessObjectDefinitionDescriptiveInformationUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectDefinition>;
    public businessObjectDefinitionUpdateBusinessObjectDefinitionDescriptiveInformation(namespace: string, businessObjectDefinitionName: string, businessObjectDefinitionDescriptiveInformationUpdateRequest: BusinessObjectDefinitionDescriptiveInformationUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectDefinition>>;
    public businessObjectDefinitionUpdateBusinessObjectDefinitionDescriptiveInformation(namespace: string, businessObjectDefinitionName: string, businessObjectDefinitionDescriptiveInformationUpdateRequest: BusinessObjectDefinitionDescriptiveInformationUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectDefinition>>;
    public businessObjectDefinitionUpdateBusinessObjectDefinitionDescriptiveInformation(namespace: string, businessObjectDefinitionName: string, businessObjectDefinitionDescriptiveInformationUpdateRequest: BusinessObjectDefinitionDescriptiveInformationUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectDefinitionUpdateBusinessObjectDefinitionDescriptiveInformation.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling businessObjectDefinitionUpdateBusinessObjectDefinitionDescriptiveInformation.');
        }
        if (businessObjectDefinitionDescriptiveInformationUpdateRequest === null || businessObjectDefinitionDescriptiveInformationUpdateRequest === undefined) {
            throw new Error('Required parameter businessObjectDefinitionDescriptiveInformationUpdateRequest was null or undefined when calling businessObjectDefinitionUpdateBusinessObjectDefinitionDescriptiveInformation.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<BusinessObjectDefinition>(`${this.configuration.basePath}/businessObjectDefinitionDescriptiveInformation/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}`,
            businessObjectDefinitionDescriptiveInformationUpdateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
